// extracted by mini-css-extract-plugin
export default {"lists":"Toplists_lists__OoSLa","list":"Toplists_list__OsvAS","item":"Toplists_item__Fa9B+","title":"Toplists_title__UoW+L"};